import React from 'react';
import MaskedInput from 'react-text-mask';

import { translate } from 'components/translate';
import PropTypes from 'prop-types';

const InputMask = ({ t, placeholder, data, ...props }) => (
  <MaskedInput placeholder={t(placeholder, { data })} {...props} />
);

InputMask.propTypes = {
  t: PropTypes.func,
  placeholder: PropTypes.string,
  data: PropTypes.object
};

export default translate()(InputMask);
